/**
 * See also FormPlugins/useDatePreferences.tsx
 */

export const databaseDateFormat = 'YYYY-MM-DD';
